const ACTION_MAP = {
  elaborateNotePrompt: "elaborate",
  rewriteNotePrompt: "rewrite",
  polishNotePrompt: "polish",
  behavior: "behavior",
  response: "response",
  plan: "plan",
};

export const normalizeAction = (key) => ACTION_MAP[key] ?? key;

export const trackAiSuggestionShown = (props) => {
  try {
    window.pendo?.track?.("ai_suggestion_shown", { ...props, timestamp: new Date().toISOString() });
  } catch {
    // never block the user
  }
};

export const trackAiSuggestionResolved = (props) => {
  try {
    window.pendo?.track?.("ai_suggestion_resolved", { ...props, timestamp: new Date().toISOString() });
  } catch {
    // never block the user
  }
};

export const trackAiNoteFinalized = (props) => {
  try {
    window.pendo?.track?.("ai_note_finalized", { ...props, timestamp: new Date().toISOString() });
  } catch {
    // never block the user
  }
};

// ─── OD-1230 SkAi token bucket analytics ───────────────────────────────────────
// The AI endpoints return a `skaiTokens` breakdown on both success (200) and
// out-of-tokens (403), so these fire from the API call sites with no extra request.

// A request was served. `fromFree` / `fromPurchased` give the per-bucket split, so a
// funnel can show how much of the paid balance real usage actually reaches.
export const trackSkaiRequestServed = (props) => {
  try {
    window.pendo?.track?.("skai_request_served", { ...props, timestamp: new Date().toISOString() });
  } catch {
    // never block the user
  }
};

// A request was rejected because free + purchased couldn't cover it.
export const trackSkaiOutOfTokens = (props) => {
  try {
    window.pendo?.track?.("skai_out_of_tokens", { ...props, timestamp: new Date().toISOString() });
  } catch {
    // never block the user
  }
};

// Tokens were added to the purchased bucket.
export const trackSkaiTokenPurchase = (props) => {
  try {
    window.pendo?.track?.("skai_token_purchase", { ...props, timestamp: new Date().toISOString() });
  } catch {
    // never block the user
  }
};

// The monthly free allocation refilled. Detected client-side by comparing the
// `freeResetAt` the API reports against the last one this browser saw, since the
// reset itself happens in a backend cron with no user session attached.
export const trackSkaiFreeReset = (props) => {
  try {
    window.pendo?.track?.("skai_free_reset", { ...props, timestamp: new Date().toISOString() });
  } catch {
    // never block the user
  }
};
